/** @preserve
Copyright © 2014 Clean Power Research, LLC. All rights reserved.

NO PART OF THIS FILE MAY BE COPIED OR ALTERED WITHOUT WRITTEN PERMISSION
FROM CLEAN POWER RESEARCH, LLC.
*/

// Adds the manufacturerId manufacturer from the storedPvModels list to the manufList if it is not already present
export function extendManufacturerList(manufList, manufId, storedPvModels) {
    let clearManufId = false;

    const manufIsOnList = manufList.some((m) => {
        return m.ManufacturerDefinitionId === parseInt(manufId);
    });

    if (!manufIsOnList) {
        // Any model for this manufacturer will do
        const storedPvModel = storedPvModels.find((m) => {
            return m.Manufacturer.ManufacturerDefinitionId === parseInt(manufId);
        });

        // It's theoretically possible that an obsolete manufacturer could have been saved without a model selected,
        //  so we can't assume that there will be a stored model for this manufacturer
        if (storedPvModel) {
            manufList.push({
                ManufacturerDefinitionId: storedPvModel.Manufacturer.ManufacturerDefinitionId,
                ListedName: storedPvModel.Manufacturer.ListedName,
                IsObsolete: true
            });

            manufList.sort((a, b) => (a.ListedName > b.ListedName ? 1 : -1));
        } else {
            // If there isn't a model for this manufacturer, there's no reason to keep the obsolete manufacturer selection
            clearManufId = true;
        }
    }

    return clearManufId;
}

// Adds the modelId model from the storedPvModels list to the modelList if it is not already present
export function extendModelList(modelList, modelId, storedPvModels, updatedModelSuffix) {
    const modelIsOnList = modelList.some((m) => {
        return m.ModelId === parseInt(modelId);
    });

    if (!modelIsOnList) {
        // Look for model in the stored PV models list
        const storedPvModel = storedPvModels.find((m) => {
            return m.Model.ModelId === parseInt(modelId);
        });

        // This should only happen if there is a manufacturer-model mismatch, but since there are still
        //  some in the wild, return instead of crashing reading the storedPvModel.Model below
        if (storedPvModel === undefined) {
            return;
        }

        // If there is an updated version of this model in the list, add a suffix to the name to indicate this
        const updatedModelIndex = modelList.findIndex((m) => {
            return m.Name === storedPvModel.Model.Name;
        });
        if (updatedModelIndex >= 0) {
            modelList[updatedModelIndex].Name += updatedModelSuffix;
        }

        // Now add the stored model to the master list
        modelList.push({
            ManufacturerId: storedPvModel.Model.ManufacturerId,
            ModelId: storedPvModel.Model.ModelId,
            Name: storedPvModel.Model.Name,
            SortRating: storedPvModel.Model.SortRating,
            Rating: storedPvModel.Model.Rating,
            Smart: storedPvModel.Model.Smart,
            ModelAttributes: storedPvModel.Model.ModelAttributes,
            IsMicroInverter: storedPvModel.Model.IsMicroInverter,
            ModelInformation: storedPvModel.Model.ModelInformation
        });

        // Re-sort the new item into the list
        modelList.sort((a, b) => (a.SortRating > b.SortRating ? 1 : -1));
    }
}
